import { createActions, handleActions } from 'redux-actions';

const initState = {
  summaryData: [],
  detailData: [],
  fetching: false,
  error: null,
};

export const creators = createActions({
  FEESPROJECTION_SUMMARY_REQUEST: (selectedYears, DateKey) => ({
    selectedYears,
    DateKey,
  }),
  FEESPROJECTION_DETAIL_REQUEST: (selectedYears, DateKey) => ({
    selectedYears,
    DateKey,
  }),
  FEESPROJECTION_SUCCESS: (payload) => payload,
  FEESPROJECTION_FAILURE: (payload) => payload,
});

const summaryReducer = (state) => {
  return {
    ...state,
    fetching: true,
    error: null,
  };
};

const detailReducer = (state) => {
  return {
    ...state,
    fetching: true,
    error: null,
  };
};

const successReducer = (state, { payload }) => {
  const nextState = Object.assign({}, state, payload);
  nextState.fetching = false;
  return nextState;
};

const failureReducer = (state, { payload }) => {
  return { ...state, fetching: false, error: payload };
};

export default handleActions(
  {
    FEESPROJECTION_SUMMARY_REQUEST: summaryReducer,
    FEESPROJECTION_DETAIL_REQUEST: detailReducer,
    FEESPROJECTION_SUCCESS: successReducer,
    FEESPROJECTION_FAILURE: failureReducer,
  },
  initState,
);
